'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_navigation_Button_BaseButton = require('./BaseButton.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

function Button(_a) {
  var { color = "primary", size = "medium" } = _a, props = tslib_es6.__rest(_a, ["color", "size"]);
  return React__default.default.createElement(components_navigation_Button_BaseButton.BaseButton, Object.assign({ color, size }, props));
}

exports.Button = Button;
//# sourceMappingURL=Button.cjs.js.map
